'use es6';

import Raven from 'raven-js';
import { EntityStatus } from 'AdsUI/lib/Constants';
const EFFECTIVE_STATUS_MAP = {
  ADSET_PAUSED: EntityStatus.ADGROUP_PAUSED,
  CAMPAIGN_PAUSED: EntityStatus.CAMPAIGN_PAUSED,
  PENDING_BILLING_INFO: EntityStatus.PENDING_REVIEW,
  PENDING_REVIEW: EntityStatus.PENDING_REVIEW,
  PREAPPROVED: EntityStatus.ACTIVE
};
const STATUS_MAP = {
  ACTIVE: EntityStatus.ACTIVE,
  ARCHIVED: EntityStatus.DELETED,
  CANCELED: EntityStatus.DELETED,
  COMPLETED: EntityStatus.COMPLETED,
  DELETED: EntityStatus.DELETED,
  DISABLED: EntityStatus.DELETED,
  DISAPPROVED: EntityStatus.NOT_APPROVED,
  DRAFT: EntityStatus.DRAFT,
  ENABLED: EntityStatus.ACTIVE,
  PAUSED: EntityStatus.PAUSED,
  PENDING_REVIEW: EntityStatus.PENDING_REVIEW,
  REMOVED: EntityStatus.DELETED,
  UNKNOWN: EntityStatus.DELETED
};
export const campaignStatus = campaignEntity => {
  if (campaignEntity.effectiveStatus && EFFECTIVE_STATUS_MAP[campaignEntity.effectiveStatus]) {
    return EFFECTIVE_STATUS_MAP[campaignEntity.effectiveStatus];
  } // Special case for scheduled and completed


  const now = Date.now();

  if (typeof campaignEntity.startTime === 'number' && campaignEntity.startTime > now) {
    return EntityStatus.SCHEDULED;
  }

  if (typeof campaignEntity.endTime === 'number' && campaignEntity.endTime > 0 && campaignEntity.endTime < now) {
    return EntityStatus.COMPLETED;
  }

  if (STATUS_MAP[campaignEntity.status]) {
    return STATUS_MAP[campaignEntity.status];
  }

  Raven.captureMessage('Unknown campaign status', {
    extra: {
      entity: campaignEntity.toJSON()
    }
  });
  return EntityStatus.ACTIVE;
};
const ROLLUP_STATUSES = [EntityStatus.COMPLETED, EntityStatus.SCHEDULED];
const ANCESTOR_PAUSED = ['ADSET_PAUSED', 'CAMPAIGN_PAUSED'];
export const adGroupStatus = (adGroupEntity, campaignEntity) => {
  const campaignEntityStatus = campaignStatus(campaignEntity);

  if (ROLLUP_STATUSES.indexOf(campaignEntityStatus) > -1) {
    return campaignEntityStatus;
  }

  if (adGroupEntity && adGroupEntity.effectiveStatus && EFFECTIVE_STATUS_MAP[adGroupEntity.effectiveStatus]) {
    // The entity being paused overrides the fact that an ancestor may be paused
    if (adGroupEntity.status === EntityStatus.PAUSED && ANCESTOR_PAUSED.indexOf(adGroupEntity.effectiveStatus) > -1) {
      return EntityStatus.PAUSED;
    }

    return EFFECTIVE_STATUS_MAP[adGroupEntity.effectiveStatus];
  }

  if (adGroupEntity && STATUS_MAP[adGroupEntity.status]) {
    return STATUS_MAP[adGroupEntity.status];
  }

  Raven.captureMessage('Unknown ad group status', {
    extra: {
      entity: adGroupEntity && adGroupEntity.toJSON()
    }
  });
  return EntityStatus.ACTIVE;
};
export const adStatus = (adEntity, adGroupEntity, campaignEntity) => {
  const campaignEntityStatus = campaignStatus(campaignEntity);
  const adGroupEntityStatus = adGroupStatus(adGroupEntity, campaignEntity);

  if (ROLLUP_STATUSES.indexOf(adGroupEntityStatus) > -1) {
    return adGroupEntityStatus;
  }

  if (ROLLUP_STATUSES.indexOf(campaignEntityStatus) > -1) {
    return campaignEntityStatus;
  }

  if (adEntity.effectiveStatus && EFFECTIVE_STATUS_MAP[adEntity.effectiveStatus]) {
    // The entity being paused overrides the fact that an ancestor may be paused
    if (adEntity.status === EntityStatus.PAUSED && ANCESTOR_PAUSED.indexOf(adEntity.effectiveStatus) > -1) {
      return EntityStatus.PAUSED;
    }

    return EFFECTIVE_STATUS_MAP[adEntity.effectiveStatus];
  }

  if (STATUS_MAP[adEntity.status]) {
    return STATUS_MAP[adEntity.status];
  }

  Raven.captureMessage('Unknown ad status', {
    extra: {
      entity: adEntity.toJSON()
    }
  });
  return EntityStatus.ACTIVE;
};